import Product from './Product';
export default Product;
export { default as getData } from './getData';